import React from 'react';
import { motion } from 'framer-motion';
const stats = [{
  label: 'Verticals',
  value: '5+'
}, {
  label: 'Workflows Automated',
  value: '100+'
}, {
  label: 'Security',
  value: 'Enterprise-Grade'
}, {
  label: 'Approach',
  value: 'Human-in-the-Loop'
}];
export function TrustSection() {
  return <section className="py-32 bg-[#050505] relative z-10 border-t border-white/5" data-id="element-779">
      <div className="max-w-7xl mx-auto px-6" data-id="element-780">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="mb-24" data-id="element-781">
          <h2 className="font-display text-4xl md:text-5xl text-white tracking-tight leading-[1.0] text-balance" data-id="element-782">
            Why Aijentik.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-16 mb-32" data-id="element-783">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} data-id="element-784">
            <h3 className="text-2xl font-medium text-white mb-6 tracking-tight" data-id="element-785">
              Built for Depth
            </h3>
            <p className="text-gray-400 leading-relaxed text-lg font-light" data-id="element-786">
              Every agent is designed around real industry workflows and
              operational nuances. Not generic automation.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-787">
            <h3 className="text-2xl font-medium text-white mb-6 tracking-tight" data-id="element-788">
              Implementation-Ready
            </h3>
            <p className="text-gray-400 leading-relaxed text-lg font-light" data-id="element-789">
              Production-grade from day one, built to integrate, govern, and
              scale securely within your environment.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} data-id="element-790">
            <h3 className="text-2xl font-medium text-white mb-6 tracking-tight" data-id="element-791">
              Operational Context
            </h3>
            <p className="text-gray-400 leading-relaxed text-lg font-light" data-id="element-792">
              Understands the rules that matter, compliance, and SLAs. It
              doesn't just generate text; it executes business logic.
            </p>
          </motion.div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-12 pt-16 border-t border-white/5" data-id="element-793">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} data-id="element-794">
              <div className="text-4xl md:text-5xl font-display text-white mb-4 tracking-tight" data-id="element-795">
                {stat.value}
              </div>
              <div className="text-xs text-brand-orange font-medium uppercase tracking-[0.25em]" data-id="element-796">
                {stat.label}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}